import React from "react";

import {
    createComponentBase,
    BaseComponentProps,
} from "../../../../../libs/components";
import { Dropdown } from "../../../../atoms/dropdown";
import { useOktaUserListQuery } from "../../../../../store/okta/userSlice";
import { DropdownOptionsType } from "../../../../../types";
import { useGetSaaSToolByUserQuery } from "../../../../../store/requestManagement/requestSlice";

export interface RemoveUsersProps extends BaseComponentProps {
    payload: any;
    setPayload: (payload: any) => void;
    approverList: any;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RemoveUsersRequest = ({
    className,
    payload,
    setPayload,
    approverList,
    setLoading,
}: RemoveUsersProps) => {
    const componentClassName = "o-remove-users-request";
    const { Container } = createComponentBase(componentClassName, "div");
    const modifiers = {};

    const [approverName, setApproverName] = React.useState<any>([]);
    const [email, setEmail] = React.useState<string>("");
    const { data: users, isLoading: userLoading } = useOktaUserListQuery({});
    const { data: saasToolByUserData, isLoading: saasToolUserLoading, isFetching: saasToolUserFetching } = useGetSaaSToolByUserQuery(email, {
        skip: email === "",
    });

    React.useEffect(() => {
        if (saasToolByUserData?.result) {
            const manager = saasToolByUserData?.result?.manager;
            setApproverName([{
                value: manager?.email,
                label: manager?.middleName
                    ? `${manager?.firstName} ${manager?.middleName} ${manager?.lastName}`
                    : `${manager?.firstName} ${manager?.lastName}`,
            }]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saasToolByUserData]);

    const changeHandler = (value: DropdownOptionsType, index: number) => {
        const newUsers = [...payload.users];
        newUsers[index] = {
            value: value.value as string,
            label: value.label as string,
        };
        setEmail(value.value as string);

        setPayload({
            ...payload,
            users: newUsers
        });
    };

    React.useEffect(() => {
        setLoading(userLoading || saasToolUserLoading || saasToolUserFetching);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userLoading, saasToolUserLoading, saasToolUserFetching]);

    return (
        <Container className={className} modifiers={modifiers}>
            <div className={`${componentClassName}__form`}>
                {payload?.users?.map((user: any, index: number) => (
                    <div className={`${componentClassName}__form__items`} key={index}>
                        <div className={`${componentClassName}__form__item`} key={index}>
                            <label className={`${componentClassName}__form__item__label`}>User</label>
                            <Dropdown
                                className={`${componentClassName}__form__item__dropdown`}
                                options={users?.result?.data.map((item: any) => ({
                                    value: item?.email,
                                    label: item?.middleName
                                        ? `${item?.firstName} ${item?.middleName} ${item?.lastName}`
                                        : `${item?.firstName} ${item?.lastName}`,
                                }))}

                                onClickChange={(val) => changeHandler(val, index)}
                                isRequired
                                placeholder="Select User"
                            />
                        </div>
                        <div className={`${componentClassName}__form__item`} key={index}>
                            <label className={`${componentClassName}__form__item__label`}>Approves Name</label>
                            <Dropdown
                                className={`${componentClassName}__form__item__dropdown`}
                                options={[]}
                                onClickChange={() => { }}
                                placeholder="Approver Name"
                                isIcon
                                color="black"
                                selected={approverName}
                                isMulti
                                isDisabled
                            />
                        </div>
                    </div>
                ))}
            </div>
        </Container>);
};
